import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { usersDeleteRequest } from '../actions'
import { Button, Picker } from '../../root/components/common'

const useStyles = makeStyles(theme => ({
    modalButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15
    },
    userDeleteRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15
    }
}))

export default function DeleteUsersModal(props){
    const classes = useStyles()
    const dispatch = useDispatch()

    const { locale } = useSelector(state => state.main)

    const { setOpen, usersToDelete, setUsersToDelete } = props

    const deleteUsers = (users) => {
        const deleteBody = {
            users: users.map(u => ({
                user_id: Number(u.id),
                customer_id: Number(u.customer_id_delete)
            }))
        }
        dispatch(usersDeleteRequest(deleteBody))
        setOpen(false)
    }

    const onUserToDeletePickerChange = idx => customerId => {
        usersToDelete[idx].customer_id_delete = customerId
        const newUsersToDelete = [...usersToDelete]
        setUsersToDelete(newUsersToDelete)
    }

    const onCancelDeleteClick = () => {
        setOpen(false)
    }

    return (
        <React.Fragment>
            {/* {usersToDelete.some(u => u.customers.length > 1) &&
                <React.Fragment>
                    <div>
                        {locale.userManagement.pickOrgToDeleteUser}
                    </div>
                    <div>
                        {usersToDelete.map((u, idx) => {
                            return (
                                <div
                                    key={idx}
                                    className={classes.userDeleteRow}
                                >
                                    <div>
                                        {u.name}
                                    </div>
                                    <div>
                                        <Picker
                                            onChange={onUserToDeletePickerChange(idx)}
                                            value={u.customer_id_delete}
                                            options={u.customersOpts}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </React.Fragment>
            }
            {usersToDelete.length === 1 && usersToDelete.every(u => u.customers.length === 1) &&
                <div>
                    {locale.userManagement.sureDeleteUser}
                </div>
            }
            {usersToDelete.length > 1 && usersToDelete.every(u => u.customers.length === 1) &&
                <div>
                    {locale.userManagement.sureDeleteUsers}
                </div>
            } */}
            <div>
                {locale.userManagement.sureDeleteUser}
            </div>
            <div className={classes.modalButtons}>
                <Button onClick={deleteUsers.bind(this, usersToDelete)}>
                    {locale.common.delete}
                </Button>
                <Button reverted onClick={onCancelDeleteClick}>
                    {locale.common.cancel}
                </Button>
            </div>
        </React.Fragment>
    )
}
